const {
  knownPages: {
    catalogue,
    contactUs,
    historyList,
    orderList,
    wishList,
    profile,
    extraServices,
    checkout,
    partnership,
  },
} = window.freedomeConfig;

const pages = {
  catalogue,
  contactUs,
  historyList,
  orderList,
  wishList,
  profile,
  extraServices,
  checkout,
  partnership,
};

export default pages;
